export default __webpack_public_path__ + "media/plus/plus-balls-semi-19a0604b.png";